import clsx from 'clsx';
import React from 'react';

import { DirectorySubscriber } from '../../utils/backend-api/subscriber_directory';
import ProfilesList from '../SubscriberDirectory/ProfilesList';
import styles from './styles.module.scss';

interface SearchSubscribersListProps {
  content: { profiles: DirectorySubscriber[]; currentUserId: number };
}

const SearchSubscribersList = ({ content }: SearchSubscribersListProps) => {
  return (
    <div id="SearchSubscribersList">
      <div className={clsx(styles.profilesListSection, 'list-section')}>
        <div className={styles.profilesListWrapper}>
          <ProfilesList
            currentUserId={content?.currentUserId}
            navigate={(route: string) => (window.location.href = route)}
            onSearchPage
            profiles={content?.profiles}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchSubscribersList;
